import { createWebHashHistory, createRouter } from 'vue-router';

import MainView from './MainView.vue';
import PaymentDetail from './PaymentDetail.vue';
import EORRedeem from './components/EORRedeem.vue';
import EORView from './components/EORView.vue';

const routes = [
   { path: '/c/:code', component: PaymentDetail },
   { path: '/batch/:batchId', component: MainView },
   // EOR magic-link POC (ClickUp 86ba8whkq) — public, no auth guard.
   { path: '/eor/redeem', component: EORRedeem },
   { path: '/eor/:id', component: EORView },
   { path: '/', component: MainView },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});

export default router
